<template>
  <div class="ts-bg-white ts-rounded-lg ts-p-5">
    <!-- <h3 class="ts-rounded-xl ts-font-robot ts-text-lg">{{ $t('dashboard.balance') }}</h3> -->
    <a-skeleton :active="active" :loading="active" width="10px" :paragraph="{ rows: 3 }" />
    <div class="ts-space-y-4" v-if="!active">
      <div class="ts-flex ts-justify-between ts-items-baseline ts-border-b ts-border-gray-300">
        <div>
					<h3 class="ts-text-sm ts-font-robot ts-font-light">{{ $t('dashboard.deposit') }}</h3>
				</div>
        <div>
					<h3 class="ts-text-sm ts-font-robot ts-font-semibold">{{ transaction.deposit }}</h3>
				</div>
      </div>
      <div class="ts-flex ts-justify-between ts-items-baseline ts-border-b ts-border-gray-300">
        <div>
					<h3 class="ts-text-sm ts-font-robot ts-font-light">{{ $t('dashboard.widthdraw') }}</h3>
				</div>
        <div>
					<h3 class="ts-text-sm ts-font-robot ts-font-semibold">{{ transaction.widthdraw }}</h3>
				</div>
      </div>
      <div class="ts-flex ts-justify-between ts-items-baseline">
        <div>
					<h3 class="ts-text-sm ts-font-robot ts-font-light">{{ $t('dashboard.dealerPayout') }}</h3>
				</div>
        <div>
					<h3 class="ts-text-sm ts-font-robot ts-font-semibold">{{ transaction.payout_claim }}</h3>
				</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'totalDealer',
  data() {
    return {
      active: false,
      transaction: {}
    }
  },
  created(){
    this.onFetchData()
  },
  methods: {
    ...mapActions('dashboard/record', ['balance']),
    onFetchData(){
      this.active = true
      this.balance()
        .then(response => {
          this.transaction = response.data
        })
        .finally(() => {
          this.active = false
        })
    }
  }
}
</script>